import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=71b9071f&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b9071f')) {
      api.createRecord('71b9071f', component.options)
    } else {
      api.reload('71b9071f', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=71b9071f&", function () {
      api.rerender('71b9071f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/Breadcrumbs.vue"
export default component.exports